import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f2ffe31"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "logs-view"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "panel" }
const _hoisted_17 = { class: "row align-items-center" }
const _hoisted_18 = { class: "col-auto ml-auto" }
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pb-2 pt-4 col-12",
  style: {"text-align":"center"}
}, "Нет данных", -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_loading = _resolveComponent("tirscript3-loading")!
  const _component_tirscript3_table_header_item = _resolveComponent("tirscript3-table-header-item")!
  const _component_tirscript3_table_body_item = _resolveComponent("tirscript3-table-body-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tirscript3_table = _resolveComponent("tirscript3-table")!
  const _component_tirscript3_pagination = _resolveComponent("tirscript3-pagination")!

  return (_ctx.filter)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_tirscript3_loading, { loading: _ctx.isLoading }, null, 8, ["loading"]),
        _createVNode(_component_tirscript3_table, {
          items: _ctx.items,
          "template-columns": "150px 100px 300px 190px 305px 120px auto 120px",
          style: {"overflow-x":"auto"}
        }, {
          header: _withCtx(() => [
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode("Дата")
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode("Уровень")
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode("Class/ "),
                _hoisted_2,
                _createTextVNode("Метод")
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode(" Размеры и время Request / Response/Time ")
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode(" SessionToken"),
                _hoisted_3,
                _createTextVNode(" RequestId "),
                _hoisted_4,
                _createTextVNode("ConnectionId"),
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode("UserId/ "),
                _hoisted_6,
                _createTextVNode(" Ip")
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode(" ProjectName (ProjectId)"),
                _hoisted_7,
                _createTextVNode(" ServerName"),
                _hoisted_8,
                _createTextVNode(" InstanceName"),
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode("Действия")
              ]),
              _: 1
            })
          ]),
          body: _withCtx((data) => [
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["table-item", [_ctx.type(data.item)]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.DateFormat(data.item.DateStart)), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["table-item", [_ctx.type(data.item)]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.LogLevel(data.item.LevelId)), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["table-item", [_ctx.type(data.item)]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.item.Class) + " ", 1),
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(data.item.Method), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["table-item", [_ctx.type(data.item)]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.item.RequestLength) + "байт / " + _toDisplayString(data.item.ResponseLength) + "байт / " + _toDisplayString(_ctx.getIntervalTime(data.item.DateStart, data.item.DateEnd)) + "ms ", 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["session-token table-item", [_ctx.type(data.item)]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.item.SessionToken) + " ", 1),
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(data.item.RequestId) + " ", 1),
                _hoisted_12,
                _createTextVNode(_toDisplayString(data.item.ConnectionId), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["table-item", [_ctx.type(data.item)]])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.item.UserId) + "/ ", 1),
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(data.item.Ip), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["table-item", [_ctx.type(data.item)]]),
              title: data.item.ProjectName + '(' + data.item.ProjectLogGroupId + ')'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.item.ProjectName) + "( " + _toDisplayString(data.item.ProjectLogGroupId) + ")", 1),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(data.item.ServerName), 1),
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(data.item.InstanceName), 1)
              ]),
              _: 2
            }, 1032, ["class", "title"]),
            _createVNode(_component_tirscript3_table_body_item, {
              class: _normalizeClass(["table-item", [_ctx.type(data.item)]])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: {
              name: 'logs-view-detail',
              params: { id: data.item.RequestId, isActive: _ctx.isActive },
            },
                  class: "detale"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Просмотр ")
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 1
        }, 8, ["items"]),
        _withDirectives(_createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_tirscript3_pagination, {
                ref: "pagination",
                size: _ctx.pageResponse.Size,
                count: _ctx.pageResponse.Count,
                class: "mt-4",
                onOnChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPaginationChanged($event)))
              }, null, 8, ["size", "count"])
            ])
          ])
        ], 512), [
          [_vShow, !_ctx.noPagination && _ctx.items && _ctx.items.length > 0]
        ]),
        (!_ctx.noPagination && _ctx.items && _ctx.items.length == 0 && _ctx.isLoading == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}